module.exports = __webpack_public_path__ + "static/media/dark_no_data.44c0669f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-new/dark_no_data.png
// module id = 663
// module chunks = 0